import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PartiallyAddressedMailComponent } from './partially-addressed-mail.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PurchaseEmissionsModule } from '../purchase-emissions/purchase-emissions.module';

@NgModule({
  declarations: [
    PartiallyAddressedMailComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PurchaseEmissionsModule
  ],
  exports: [
    PartiallyAddressedMailComponent
  ]
})
export class PartiallyAddressedMailModule { }
